import React, { useMemo, useState } from "react";
import {
  Container,
  Title,
  SearchArea,
  ButtonContainer,
  BlueButton,
} from "../Labels/styled";
import { useDispatch, useSelector } from "react-redux";
import {
  checklistCreate,
  checklistItemAdd,
  generateChecklist,
} from "../../../../../../Services/cardService";

const LoadingOverlay = () => (
  <div
    style={{
      position: "absolute",
      inset: 0,
      background: "rgba(255, 255, 255, 0.75)",
      zIndex: 20,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",
      pointerEvents: "all",
    }}
  >
    <div className="spinner" />
    <div style={{ marginTop: "0.5rem", fontSize: "0.9rem", color: "#555" }}>
      Đang tạo checklist…
    </div>
  </div>
);

const ChecklistPopover = (props) => {
  const dispatch = useDispatch();
  const thisCard = useSelector((state) => state.card);

  const [title, setTitle] = useState("");
  const [aiChecklist, setAiChecklist] = useState([]);
  const [loading, setLoading] = useState(false);

  // Add single checklist item (manual)
  const handleAddClick = async () => {
    if (!title.trim()) return;

    await checklistCreate(
      thisCard.cardId,
      thisCard.listId,
      thisCard.boardId,
      title,
      dispatch
    );

    setTitle("");
    props.closeCallback();
  };

  // Generate checklist from AI
  const handleGenerateClick = async () => {
    setLoading(true);

    try {
      const content = await generateChecklist(
        thisCard.cardId,
        thisCard.listId,
        thisCard.boardId,
        props.taskTitle,
        title,
        dispatch
      );
      const data = JSON.parse(content);
      if (data?.checklist) {
        setAiChecklist(
          data.checklist.map((item, index) => ({
            id: `${Date.now()}-${index}`,
            text: item,
          }))
        );
      }
    } catch (err) {
      console.error("Generate checklist failed", err);
    } finally {
      setLoading(false);
    }
  };

  // Edit AI item
  const handleEditItem = (id, value) => {
    setAiChecklist((prev) =>
      prev.map((item) => (item.id === id ? { ...item, text: value } : item))
    );
  };

  // Delete AI item
  const handleDeleteItem = (id) => {
    setAiChecklist((prev) => prev.filter((item) => item.id !== id));
  };

  // Save all AI checklist items
  const handleSaveAIChecklist = async () => {
    setLoading(true);
    const curentTitle = !title.trim() ? props.taskTitle : title;

    const checkListId = await checklistCreate(
      thisCard.cardId,
      thisCard.listId,
      thisCard.boardId,
      curentTitle,
      dispatch
    );

    for (const item of aiChecklist) {
      if (!item.text.trim()) continue;

      await checklistItemAdd(
        thisCard.cardId,
        thisCard.listId,
        thisCard.boardId,
        checkListId,
        item.text,
        dispatch
      );
    }

    setAiChecklist([]);
    setLoading(false);
    props.closeCallback();
  };

  const isTitleEmpty = useMemo(() => title.trim() === "", [title]);

  return (
    <Container>
      {/* Manual add */}
      {loading && <LoadingOverlay />}
      <Title>Tiêu đề</Title>
      <SearchArea
        placeholder="Tiêu đề..."
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <ButtonContainer>
        <BlueButton
          style={{
            width: "4rem",
            backgroundColor: isTitleEmpty ? "#ccc" : undefined,
            cursor: isTitleEmpty ? "not-allowed" : "pointer",
            opacity: isTitleEmpty ? 0.7 : 1,
          }}
          onClick={handleAddClick}
          disabled={isTitleEmpty}
        >
          Tạo
        </BlueButton>

        <BlueButton
          style={{
            width: "10rem",
            marginLeft: "0.5rem",
            backgroundColor: loading ? "#ccc" : undefined,
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
          }}
          onClick={handleGenerateClick}
          disabled={loading}
        >
          {loading ? "Đang suy nghĩ..." : "Tạo checklist với AI"}
        </BlueButton>
      </ButtonContainer>

      {/* AI checklist preview */}
      {aiChecklist.length > 0 && (
        <>
          <Title style={{ marginTop: "1rem" }}>AI Checklist</Title>

          {aiChecklist.map((item) => (
            <div
              key={item.id}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0.5rem",
              }}
            >
              <input
                value={item.text}
                onChange={(e) => handleEditItem(item.id, e.target.value)}
                style={{
                  width: `${Math.max(item.text.length, 5)}ch`,
                  maxWidth: "100%",
                  padding: "6px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                }}
              />

              <button
                onClick={() => handleDeleteItem(item.id)}
                style={{
                  marginLeft: "0.5rem",
                  background: "transparent",
                  border: "none",
                  color: "red",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </div>
          ))}

          <BlueButton
            style={{
              width: "100%",
              marginTop: "0.5rem",
            }}
            onClick={handleSaveAIChecklist}
          >
            Thêm Checklist trên
          </BlueButton>
        </>
      )}
    </Container>
  );
};

export default ChecklistPopover;
